import { render, staticRenderFns } from "./SearaTemplate.vue?vue&type=template&id=16ac582f&scoped=true&"
import script from "./SearaTemplate.vue?vue&type=script&lang=js&"
export * from "./SearaTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SearaTemplate.vue?vue&type=style&index=0&id=16ac582f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac582f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VCard,VCardText,VCol,VImg,VRow})
